import type { RescheduleContextDto } from '@shared/core/reschedule'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { RescheduleService } from 'src/services/reschedule.service'

export const GET_RESCHEDULE_CONTEXT_CACHE_KEY = 'reschedule-context'

export function useRescheduleContextByUrl(urlCode: string, options?: UseQueryOptions<RescheduleContextDto>) {
  const handleRetry = useHandleRetry()
  return useQuery([GET_RESCHEDULE_CONTEXT_CACHE_KEY, urlCode], () => RescheduleService.getContext(urlCode), {
    enabled: !!urlCode,
    staleTime: ms('5 minutes'),
    retry: handleRetry,
    ...options,
  })
}
